import React, { useState, useEffect, useRef } from 'react';
import api from '../../services/api';
import s from '../../pages/PedidosOrcamentos.module.css';
import useNavegacaoLista from '../../hooks/useNavegacaoLista';

/**
 * Seletor de cliente autocontido — usado quando a emissão de NF-e é barrada
 * porque a venda está no VENDA CONSUMIDOR: o operador escolhe o cliente
 * devidamente cadastrado sem sair do fluxo de emissão.
 * Props: titulo?, onSelect(cliente), onClose()
 */
export default function ModalSelecionarCliente({ titulo, onSelect, onClose }) {
  const [busca, setBusca] = useState('');
  const [lista, setLista] = useState([]);
  const [buscando, setBuscando] = useState(false);
  const [sel, setSel] = useState(null);
  const debRef = useRef(null);
  const inputRef = useRef(null);

  useEffect(() => { inputRef.current?.focus(); }, []);

  useEffect(() => {
    clearTimeout(debRef.current);
    debRef.current = setTimeout(async () => {
      setBuscando(true);
      try {
        const { data } = await api.get('/clientes', { params: { busca: busca || undefined, limite: 15 } });
        setLista((Array.isArray(data) ? data : []).filter(c => c.id !== 1)); // NF-e: nunca o consumidor
      } catch { setLista([]); }
      finally { setBuscando(false); }
    }, 300);
    return () => clearTimeout(debRef.current);
  }, [busca]);

  const refLinha = useNavegacaoLista({
    lista, indice: lista.findIndex(c => c.id === sel?.id), aoMudar: setSel, aoEnter: onSelect,
  });

  return (
    // zIndex alto: abre POR CIMA de qualquer modal do PDV/Pedidos (F7 usa 1000+)
    <div className={s.overlay} data-enter-scope="off" style={{ zIndex: 99000 }}
      onMouseDown={e => e.target === e.currentTarget && onClose()}>
      <div className={s.modal} style={{ width: 560 }}>
        <div className={s.modalTitle}>👤 {titulo || 'Selecionar cliente para a NF-e'}</div>
        <div className={s.modalBody}>
          <p style={{ fontSize: 12.5, color: '#475569', margin: '0 0 8px' }}>
            A NF-e exige destinatário identificado. Escolha o cliente desta venda —
            se faltar algum dado no cadastro, você poderá completar em seguida.
          </p>
          <div className={s.modalSearchRow}>
            <input ref={inputRef} className={s.inputErp} style={{ flex: 1 }}
              placeholder="Nome, CPF/CNPJ..."
              value={busca} onChange={e => setBusca(e.target.value)}
              onKeyDown={e => e.key === 'Escape' && onClose()} />
            {buscando && <span style={{ fontSize: 12, color: '#888' }}>buscando…</span>}
          </div>
          <div style={{ maxHeight: 300, overflowY: 'auto', border: '1px solid #e2e8f0', borderRadius: 4 }}>
            <table className={s.modalTabela}>
              <thead>
                <tr><th style={{ width: 60 }}>Cód.</th><th>Nome</th><th style={{ width: 140 }}>CPF/CNPJ</th></tr>
              </thead>
              <tbody>
                {lista.length === 0 && (
                  <tr><td colSpan={3} style={{ textAlign: 'center', padding: 14, color: '#888' }}>
                    {buscando ? 'Buscando…' : 'Nenhum cliente encontrado.'}
                  </td></tr>
                )}
                {lista.map(c => (
                  <tr key={c.id} ref={sel?.id === c.id ? refLinha : null} className={sel?.id === c.id ? s.selRow : ''}
                    onClick={() => setSel(c)} onDoubleClick={() => onSelect(c)}>
                    <td>{c.codigo}</td>
                    <td>{c.nome}</td>
                    <td>{c.cpf_cnpj || '—'}</td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        </div>
        <div className={s.modalFooter}>
          <button className={`${s.btnErp} ${s.btnErpPrimario}`} disabled={!sel}
            onClick={() => sel && onSelect(sel)}>
            Usar este cliente
          </button>
          <button className={s.btnErp} onClick={onClose}>Cancelar</button>
        </div>
      </div>
    </div>
  );
}
